import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Play } from 'lucide-react';
import { gallery } from '../mock';

const Gallery = () => {
  const [lightbox, setLightbox] = useState(null);

  const prev = (e) => {
    e.stopPropagation();
    setLightbox((i) => (i - 1 + gallery.length) % gallery.length);
  };
  const next = (e) => {
    e.stopPropagation();
    setLightbox((i) => (i + 1) % gallery.length);
  };

  const getImageStyle = (item) => {
    if (!item.rotate) return undefined;
    return { transform: `rotate(${item.rotate}deg)` };
  };

  const isVideo = (item) => item?.type === 'video';

  return (
    <section id="galleri" className="py-24 md:py-36 bg-[#2f3d30] text-[#f6efe2] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 md:mb-16 reveal gap-6">
          <div>
            <p className="text-[#e8d8b4] text-xs uppercase tracking-[0.4em] mb-5">— Bildspel</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
              Ögonblick från <em className="italic font-light text-[#e8d8b4]">fjället</em>.
            </h2>
          </div>
          <p className="text-[#d6ceba] font-light max-w-md leading-relaxed">
            Ett urval av minnen från turer, träningar och livet med hästarna i Ljungdalen.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {gallery.map((item, i) => (
            <button
              key={i}
              onClick={() => setLightbox(i)}
              className="reveal img-zoom aspect-square overflow-hidden group relative bg-[#1f2a20]"
              style={{ transitionDelay: `${(i % 8) * 50}ms` }}
            >
              <img
                src={isVideo(item) ? item.poster : item.src}
                alt={`Galleri ${i + 1}`}
                className="w-full h-full object-cover"
                style={getImageStyle(item)}
              />
              <div className="absolute inset-0 bg-[#2f3d30]/0 group-hover:bg-[#2f3d30]/30 transition-colors duration-500" />
              {isVideo(item) && (
                <>
                  <div className="absolute inset-0 bg-black/30" />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-[#faf7f2]/95 flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-500">
                      <Play className="w-7 h-7 md:w-8 md:h-8 text-[#2f3d30] ml-1" strokeWidth={1.5} fill="currentColor" />
                    </span>
                  </span>
                  <span className="absolute bottom-3 left-3 text-[10px] uppercase tracking-[0.25em] text-[#faf7f2] bg-black/40 px-2 py-1 rounded-sm">
                    Video
                  </span>
                </>
              )}
            </button>
          ))}
        </div>
      </div>

      {lightbox !== null && (
        <div
          className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4 md:p-10"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-[#e8d8b4] transition-colors z-10"
            onClick={() => setLightbox(null)}
            aria-label="Close"
          >
            <X className="w-8 h-8" strokeWidth={1.2} />
          </button>
          <button
            onClick={prev}
            className="absolute left-4 md:left-8 text-white hover:text-[#e8d8b4] transition-colors z-10"
            aria-label="Previous"
          >
            <ChevronLeft className="w-10 h-10" strokeWidth={1} />
          </button>

          {isVideo(gallery[lightbox]) ? (
            <video
              key={lightbox}
              src={gallery[lightbox].src}
              poster={gallery[lightbox].poster}
              controls
              autoPlay
              playsInline
              className="max-h-[85vh] max-w-[90vw] bg-black"
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <img
              src={gallery[lightbox].src}
              alt=""
              className="max-h-[85vh] max-w-[90vw] object-contain"
              style={
                gallery[lightbox].rotate
                  ? { transform: `rotate(${gallery[lightbox].rotate}deg)`, maxHeight: '85vw', maxWidth: '85vh' }
                  : undefined
              }
              onClick={(e) => e.stopPropagation()}
            />
          )}

          <button
            onClick={next}
            className="absolute right-4 md:right-8 text-white hover:text-[#e8d8b4] transition-colors z-10"
            aria-label="Next"
          >
            <ChevronRight className="w-10 h-10" strokeWidth={1} />
          </button>
          <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[#e8d8b4] text-xs uppercase tracking-[0.3em]">
            {lightbox + 1} / {gallery.length}
          </p>
        </div>
      )}
    </section>
  );
};

export default Gallery;
